<template>
    <div style="background-color: white;">
        <h1 class="page-title letraDelTitulo enMayusculas col-12">Formulario para campos de convocatorias</h1>
    <div class="container caja-principal" >
       
    <div class="caja-contenedora-formulario">
        <div class="titulo"><h3>Datos generales de la convocatoria</h3></div><br>
        <div class="caja-formulario">
            
            <h5 class="letras-campos">Nombre de la Convocatoria <label class="asterisco-requerido">(*)</label></h5>
            <input type="text" v-model="NombreConvocatoria" class="form-control campo" placeholder="Ingrese un nombre para la convocatoria"/><br>
           <h5 class="letras-campos">Fecha de Publicación <label class="asterisco-requerido">(*)</label></h5>
           <input type="date" class="form-control campo"  name="trip-start" v-model="fechaInicio"/><br>
           <h5 class="letras-campos">Fecha Final de Publicación <label class="asterisco-requerido">(*)</label></h5>
           <input type="date" class="form-control campo"  name="trip-start" v-model="fechaFinal"/>
        </div>
       
        <br> <div class="titulo"><h3>Agregar campos para el formulario</h3></div><br>
        <div class="caja-formulario">
                      <h6 class="letras-campos">Nombre Campo <label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="Nombre" ref="Nombre_campo" :class="'form-control campo'" placeholder="Ingrese nombre completo" />
        </div>
    <div ref="formField" >    
        <div class="caja-formulario">
                      <h6 class="letras-campos">¿Es Necesario para la Convocatoria? <label class="asterisco-requerido">(*)</label></h6>
                    <select v-model="Requerido" ref="estado_requerido" :class="'form-control select-estilos'" >
                    <option disabled value="">Seleccione una Opcion</option>
                    <option value="true">SI</option>
                    <option value="false">NO</option>                   
                    </select>
        </div>

        <div class="caja-formulario">
                      <h6 class="letras-campos">¿Se requiere en el acuse? <label class="asterisco-requerido">(*)</label></h6>
                    <select v-model="VisibleEnAcuse" id="estado_acuse" :class="'form-control select-estilos'" >
                    <option disabled value="">Seleccione una Opcion</option>
                    <option value="true">SI</option>
                    <option value="false">NO</option>                   
                    </select>
        </div>

        <div class="caja-formulario">
                      <h6 class="letras-campos">Tipo de campo <label class="asterisco-requerido">(*)</label></h6>
                    <select v-model="tipo" id="tipo_campo" :class="'form-control select-estilos'" @change="validaSiEsSelect">
                    <option disabled value="">Seleccione una Opcion</option>
                    <option value="1">Texto</option>
                    <option value="2">Fecha</option>
                    <option value="3">Select</option>
                    <option value="4">Teléfono</option>
                    <option value="5">Correo</option>
                    <option value="6">Documento</option>
                    <option value="7">Curp</option>
                    <option value="8">Descripcion</option>
                    </select>
        </div>
        <br>
      <div v-if="esSelect">
       <div class="caja-formulario">
                      <h6 class="letras-campos">Nombre de la opcion <label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="NombreSelect" ref="Nombre_select" :class="'form-control campo'" placeholder="Ingrese nombre completo" />
        </div>
         <br>
         <div class="row d-flex justify-content-center">
         <div v-if ="estaActualizandoSelect==false">
        <button class="btn btn-info" @click="agregarCampoSelect">Agregar campo al select</button> 
        </div>
        <div v-if="estaActualizandoSelect">
        <button class="btn btn-info" @click="editCampoSelect">Editar campo al select</button> 
        <button class="btn btn-danger" @click="cancelarEditFormularioSelect">Cancelar Edición</button> 
        </div>
         </div>  
              <div class="row d-flex justify-content-center">
           <div  class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low  justify-content-center">
        <div class="area">
          <h4>Campos del select</h4>
       <div class="table-responsive">
           <table class="table table-striped table-light table-hover">
                   <thead class="thead-light">
                    <tr>
                        <th class="text-center">Nombre Campo Select</th>
                        <th class="text-center"></th>
                    </tr>
                   </thead>
                <tbody class="text-secondary">

                </tbody>
                <tr v-for="(camposf, index) in formularioSelect.slice().reverse()" :key="index">
                     <td>{{ camposf.opcion }}</td>
              <td><i class="fas fa-minus-circle" v-on:click="deleteCampoSelectFormulario(camposf.opcion)" title="Eliminar Campo del select"></i>
                  <i class="fas fa-pen" v-on:click="prepararSelectEdit(camposf,index)" title="Editar Campo del select"></i>
            </td>
                </tr>
                </table>

       </div></div></div></div>

           
      </div>

        <br><br>
       
 

    </div>
    
    <div v-if="estaActualizando==false">
        <div class="botones-guardar">
    <button class="btn btn-success  boton-general" @click="agregarCampo">Agregar campo</button> 
    </div>
    </div>
    
    <div v-if="estaActualizando" >
        <div class="botones-guardar">
    <button class="btn btn-success  boton-general" @click="editCampoFormulario">Editar campo</button> 
    <button class="btn btn-danger  boton-general" @click="cancelarEditFormulario">Cancelar Edición</button> 
    </div>
</div>

    <br><br><br>

    <div class="row d-flex justify-content-center">
    <div  class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low ">
        <div class="area">
          <h4>Campos del formulario</h4>
       <div class="table-responsive">
            <table class="table table-striped table-light table-hover">
                   <thead class="thead-light">
                <tr>
                  <th class="text-center">Nombre Campo</th>
                  <th class="text-center">Tipo Campo</th>
                  <th class="text-center">Es Requerido</th>
                  <th class="text-center">Visible en acuse</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody class="text-secondary">
               <tr v-for="(campos, index) in llenarformulario.slice().reverse()" :key="index">
              <td>{{ campos.Nombre }}</td>
              <td>{{ campos.tipo }}</td>
              <td>{{ campos.Requerido }}</td>
              <td>{{ campos.VisibleEnAcuse }}</td>
              <td align="center" >
                <i class="fas fa-minus-circle" v-on:click="deleteCampoFormulario(campos.Nombre)" title="Eliminar Campo"></i>
                <i class="fas fa-pen" v-on:click="prepararCampoFormularioEdit(campos)" title="Editar Campo"></i>
            </td>
               </tr>
              </tbody>
            </table></div>
       </div></div></div>

    <div class="botones-guardar">
        <br><br><br><br>
        <button class="btn btn-danger boton-general"   @click="GuardarFormulario()">Guardar Formulario</button>
    </div>

    </div></div></div>
    
    </template>

    <script>
import axios from "axios"
import api from '@/../static/js/api'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import VueMask from 'v-mask'

Vue.use(VueMask);

export default {
    
  data() {
        return{
      tipo:"",
      Nombre:'',
      Requerido:"",
      VisibleEnAcuse: "",
      idConvocatoria:1,
      activo:true,
      formulario:[],
      formularioNombre:[],
      agregar:true,
      esSelect :false,
      NombreSelect:'',
      formularioSelect:[],
      estaActualizando:false,
      NFormActualizar:"",
      estaActualizandoSelect:false,
      NFormActualizarSelect:"",
      NombreConvocatoria:'',
      fechaInicio:null,
      fechaFinal:null,
      idSelect:0  
        }}, methods:{
        
limpiarFormulario:function(){
    this.tipo="",
    this.Nombre="",
    this.Requerido=false,
    this.VisibleEnAcuse=false,
    this.formulario =[],
    this.formularioNombre=[],
    this.formularioSelect=[],
    this.NombreConvocatoria="",
    this.fechaInicio=null,
    this.fechaFinal=null

},

agregarCampo:async function(){
   
let nametipo=$("#tipo_campo").find("option:selected").html();
    
    if(this.validarFormulario()==true){
        
     this.formulario.unshift({
        Nombre : this.Nombre,
        Requerido:this.Requerido,
        VisibleEnAcuse:this.VisibleEnAcuse,
        tipo:this.tipo,
        selects:this.formularioSelect
     });
     
     this.formularioNombre.unshift({
        Nombre : this.Nombre,
        Requerido:this.Requerido,
        VisibleEnAcuse:this.VisibleEnAcuse,
        tipo:nametipo,
        selects:this.formularioSelect
     });

        this.Nombre="";
        this.Requerido="";
        this.VisibleEnAcuse="";
        this.tipo="";
        this.formularioSelect = [],
        this.esSelect=false,
        this.idSelect =0
        /*this.$refs["Nombre_campo"].value="";*/
        
        /*this.$refs.formField.reset();*/
    }else{
        
        
        if(this.tipo == 5  && this.Requerido == "false"){
            
            bootbox.dialog({                  
                                message: '<div style="text-align:center"> <br> <p style="font-size:2em" class="text-center mb-0"> Si el tipo de campo es "Correo", este siempre debe ser obligatorio".</p></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                            }
                        }
                    });
         }else{

        let dialog = bootbox.dialog({                  
                                message: '<div style="text-align:center"> <br> <p style="font-size:2em" class="text-center mb-0"> Favor de llenar todos los campos.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                            }
                        }
                    });}
     }
   
},
GuardarFormulario:async function(){
    
     let dialog = bootbox.dialog({message: '<div style="text-align:center"><i class="fas fa-spinner fa-spin" style="color:#09BCEC;font-size:3em"></i><br> <p style="font-size:2em" class="text-center mb-0"> Por favor espere mientras procesamos la información.</p></div>',
                                closeButton: false });
    const SERVIDOR = api.conexion;
    const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.convocatoriasWeb.GuardarFormularioConvocatoria;
    const END_POINT = SERVIDOR+METODO_API_AGREGAR;
    let peticion = {
        idConvocatoria: this.idConvocatoria,
        activo:this.activo,
        NombreConvocatoria:this.NombreConvocatoria,
        FechaInicio:this.fechaInicio,
        FechaFinal:this.fechaFinal,
        camposFormularios:this.formulario.slice().reverse()
    }
    console.log("peticion: ",peticion);

return axios.post(END_POINT,peticion).then(async response => {
    console.log("response:::::",response)
    dialog.modal('hide');
    if(response.data.SiHayError){
                    dialog.modal('hide');
                    bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> '+response.data.Error +'</p></div>',
                                buttons: {
                                cancel: {
                                label: "Cerrar",
                                className: 'btn-danger',
                            }
                        }
                    });
                               
                }else{
                    dialog.modal('hide');
                    this.limpiarFormulario();
                  
                    bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-check-circle" style="color: #07cf9d;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Felicidades!</p> <br> <p style="font-size:2em" class="text-center mb-0"> '+response.data.Satisfactorio+'.</p><br/><label>Link de convocatoria</label><br><input type="text" style="width: 100%;" value="'+response.data.Convocatoria+'"></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                            }
                        }
                    });
                    
                }


}).catch(e => {
                console.log("A sucedido un error en el sistema::",e.message);           
                dialog.modal('hide');
                bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-times" style="color: #cf0707;font-size:3em"></i><br> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error intentelo mas tarde.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                            }
                        }
                    });
             });

},

   validarFormulario:function(){
    
        let esValido=true;
        if(this.Nombre =="" || this.Nombre==null){
            esValido=false;
        }
        if(this.tipo =="" || this.tipo==null){
            esValido=false;
            
        }
         
         if(this.Requerido =="" || this.Requerido ==null){
             esValido=false;

         } 
         if(this.VisibleEnAcuse =="" || this.VisibleEnAcuse==null){
             esValido=false;
         }
         if(this.tipo == 5  && this.Requerido == "false"){
            esValido=false;
         }
         
        return esValido;
    },

    agregarCampoSelect:function(){
         console.log("entra aqui");
        if(this.NombreSelect=="" || this.NombreSelect==null){
             let dialog = bootbox.dialog({                  
                                message: '<div style="text-align:center"> <br> <p style="font-size:2em" class="text-center mb-0"> Favor llenar el campo "Nombre de la opcion".</p></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                            }
                        }
                    });
        }else{
            console.log("idselect inicial: ",this.idSelect);
            this.idSelect= this.idSelect + 1;
            console.log("idselect final: ",this.idSelect);
      this.formularioSelect.unshift({
        opcion : this.NombreSelect,
        index: this.idSelect
     });    
     this.NombreSelect="";
      }
      
    }, 

    validaSiEsSelect:function(){
        console.log("entra");
        if(this.tipo==3){
            this.esSelect=true;
            
        }else{ this.esSelect=false;}


    },
    deleteCampoFormulario:function(name){
        
        let index = this.formulario.findIndex((elemento,index)=>{if(elemento.Nombre===name){return true;}});
         
        this.formulario.splice(index,1);
        this.formularioNombre.splice(index,1);
    },


      editCampoFormulario: function(){
       
        let index = this.formulario.findIndex((elemento,index)=>{if(elemento.Nombre===this.NFormActualizar){return true;}});
       

         if(this.formulario[index].tipo==3 && this.tipo !=3 ){
                this.formulario.select =null;
                this.formularioNombre.select =null;
           
            
        }else{
            this.formulario[index].select = this.formularioSelect;
           
        }


        this.formulario[index].Nombre=this.Nombre;
        this.formulario[index].tipo=this.tipo;
        this.formulario[index].Requerido=this.Requerido;
        this.formulario[index].VisibleEnAcuse=this.VisibleEnAcuse;

        this.formularioNombre[index].Nombre=this.Nombre;
        this.formularioNombre[index].tipo=$("#tipo_campo").find("option:selected").html();
        this.formularioNombre[index].Requerido=this.Requerido;
        this.formularioNombre[index].VisibleEnAcuse=this.VisibleEnAcuse;

        
        
        this.NFormActualizar= "";
       this.Nombre ="";
       this.tipo="";
       this.Requerido="";
       this.VisibleEnAcuse="";
       this.estaActualizando=false;
       this.formularioSelect =[];
       this.validaSiEsSelect();
       this.estaActualizandoSelect=false;
      },
      deleteCampoSelectFormulario:function(name){
        
        let index = this.formularioSelect.findIndex((elemento,index)=>{if(elemento.opcion===name){return true;}});
        
        this.formularioSelect.splice(index,1);
    },
    
    prepararCampoFormularioEdit:function(data){
        let index = this.formulario.findIndex((elemento,index)=>{if(elemento.Nombre===data.Nombre && elemento.Requerido ==data.Requerido){return true;}});
       this.NFormActualizar= data.Nombre;
       this.Nombre =data.Nombre;
       this.tipo=this.formulario[index].tipo;
       this.Requerido=data.Requerido;
       this.VisibleEnAcuse=data.VisibleEnAcuse;
       this.estaActualizando=true;
        
       if(data.tipo=="Select"){
        
        this.tipo=3;
        this.formularioSelect =data.selects;
        this.estaActualizandoSelect=true;
        this.validaSiEsSelect();
       }
    },
    prepararSelectEdit:function(data){
       this.NFormActualizarSelect= data.opcion;
       this.estaActualizandoSelect=true;
       this.NombreSelect=data.opcion;
    },
    editCampoSelect:function(){
        if(this.NombreSelect==""|| this.NombreSelect==null){
         let dialog = bootbox.dialog({                  
                                message: '<div style="text-align:center"> <br> <p style="font-size:2em" class="text-center mb-0"> Favor llenar el campo "Nombre Campo Select" para finalizar la actualizacion.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                            }
                        }
                    });
        }else{
        let index = this.formularioSelect.findIndex((elemento,index)=>{if(elemento.opcion===this.NFormActualizarSelect){return true;}});
         console.log("entrar al edit select index: ",index)
         this.formularioSelect[index].opcion=this.NombreSelect;
        this.NFormActualizarSelect="";
        this.estaActualizandoSelect= false;
        }
        console.log("estaActualizandoSelect",this.estaActualizandoSelect);
    },
   cancelarEditFormulario:function(){
     this.NFormActualizar= "";
       this.Nombre ="";
       this.tipo="";
       this.Requerido="";
       this.VisibleEnAcuse="";
       this.estaActualizando=false;
       this.NFormActualizarSelect="";
        this.estaActualizandoSelect= false;
        this.NombreSelect="";
        this.formularioSelect = [],
        this.esSelect=false
   },
   cancelarEditFormularioSelect:function(){
        this.NFormActualizarSelect="";
        this.estaActualizandoSelect= false;
        this.NombreSelect="";
        

   },
   getTypeField:function(idtype){
    if(idtype>0){
   
   
    let peticion={
        idType:idtype
    }
     const SERVIDOR = api.conexion;
    const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.convocatoriasWeb.GetTypeField;
    const END_POINT = SERVIDOR+METODO_API_AGREGAR;
    

   return  axios.post(END_POINT,peticion).then( response => {        
        return response.data.Content;
     });    
    
    }
}
        },

        computed:{
            llenarformulario:function(){
            return this.formularioNombre
            }
        },

    mounted(){

    }
        


}
    

   </script>

   <style scoped>
   .titulo{
    background-color: black;
    text-align: center;
   }
   .linea{
    border-top: .2em solid #6c757d !important;
   }

    .caja-formulario{
        margin-left: 10em;
        margin-right: 10em;
        margin-bottom: 1.5em !important;
        display: block !important;
        color:white
    }
    .caja-principal{
          /*background-color: grey;*/  
        padding-left: 10em;
        padding-right: 10em;
        padding-bottom: 5em;

    }
    .caja-contenedora-formulario{
         background-color: rgb(255, 255, 255); 
        border-color: black;
        padding-block: 2em;
        padding-bottom: 4em;
        border-radius: 25px;
        box-shadow: 0px 0px 30px rgb(206, 206, 226);
    }
    .campo{
        background-color: #e3e2e7;
    border: none;
    color:  #6c757d;
    text-transform: uppercase;
  

    }
    textarea.campo{
      height: 8em;
    }
    .asterisco-requerido{
        color: rgb(228, 3, 3);
    }

    .letras-campos{
        color: rgb(0, 0, 0);
    }

    .select-estilos{
        background-color: #e3e2e7;
        color: #6c757d;
    }
    .pestanas{
       
        margin-bottom: 4em;
        text-align: center;
        border:solid 1px #ced0d1;
        border-radius: 5px;
        padding: .5em;
        
    }
    .boton-pestana{
        width: 40%;
    }
    .botones-guardar{
        text-align: center;
    }
    .boton-general{
        width: 15em;
    }
    .mensaje-procesando{
        font-size: 5em;
    }
    .correo-valido{
        border:solid 1px #05c484;
    }
    .correo-invalido{
        border:solid 1px #c90f08;
    }

    .page-title {
    background-color: rgb(50,50,50);
    color: #FFF;
    padding: 2vh 20vw;
    text-align: center;
    border-top: solid white 15px;

  }

  @media (max-width: 600px) {
    .page-title{
      font-size: 2em;
    }

    h2{
      font-size: 1.8em;
    }
  }



</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Convocatorias/ConvocatoriaAltaFormulario.vue